 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import BOOKDESCRIPTION from '@/components/book-description'
 import TITLEPAGE from '@/components/title-page'
 import COPYRIGHT from '@/components/copyright'
 import CONTENTS from '@/components/contents'
 import THEMILLIONDOLLARWRITINGSERIES from '@/components/the-million-dollar-writing-series'
 import INTRODUCTIONWALKINGANDTALKING from '@/components/introduction-walking-and-talking'
 import INTRODUCTIONITGETSEASIER from '@/components/introduction-it-gets-easier'
 import CHAPTER001 from '@/components/chapter-001'
 import CHAPTER002 from '@/components/chapter-002'
 import CHAPTER003 from '@/components/chapter-003'
 import CHAPTER004 from '@/components/chapter-004'
 import CHAPTER005 from '@/components/chapter-005'
 import CHAPTER006 from '@/components/chapter-006'
 import CHAPTER007 from '@/components/chapter-007'
 import CHAPTER008 from '@/components/chapter-008'
 import CHAPTER009 from '@/components/chapter-009'
 import LOVE_2 from '@/components/love_2'
 import AFTERWORD from '@/components/afterword'
 import APPENDIXSTAKEBYKEVINJANDERSON from '@/components/appendix-stake-by-kevin-j-anderson'
 import DISCLAIMERANDCREDITS from '@/components/disclaimer-and-credits'
 import ABOUTTHEAUTHORS from '@/components/about-the-authors'
 import YOUMIGHTALSOENJOY from '@/components/you-might-also-enjoy'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js